import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
//mui
import { Box, Stack, Button, Collapse } from '@mui/material';
//components
import { CenteredNarrowContent } from 'theme/elements/Content';
import { FormCard, FormsStack } from 'theme/elements/Forms';
import { FormHeader1 } from 'theme/elements/Headers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { ErrorMessage } from 'theme/elements/Text';
import { FormButton } from 'theme/elements/Buttons';
import { store } from 'state/store';
import { useEffect, useMemo } from 'react';
import { getMessage, setEditError, setEditSuccess, setMessage } from 'state/reducers/settings.reducers';
import CircularProgress from '@mui/material/CircularProgress';
import { CustomAlert } from 'theme/elements/Alerts';
import { userMessage } from 'constants/ui.constants';
import WarningDialog from 'components/WarningDialog';

export default function UserEditCard({
	children,
	handleSaveClick,
	handleCancelEdit,
	title,
	cancelButtonText,
	saveButtonText,
	dataToEdit = null,
	disabledSubmit = false,
}) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const userMessage: userMessage = useAppSelector(getMessage);
	const editError = store.getState().settings.editError;
	const loading = store.getState().translation.loading;

	useEffect(() => {
		dispatch(setEditSuccess(false));
		dispatch(setEditError(false));
	}, []);

	const openDialog = useMemo(() => {
		return userMessage.exist;
	}, [userMessage]);

	return (
		<Box>
			<WarningDialog
				open={openDialog}
				title={t(userMessage.text || '')}
				subTitle={userMessage.subText}
				handleCancel={() => {
					dispatch(setMessage({ exist: false }));
				}}
			/>
			<Stack>
				<CenteredNarrowContent>
					<FormCard>
						<FormHeader1 title={title} />
						{children}
						{!dataToEdit && (
							<Box>
								<FormButton>
									<Button
										disabled={disabledSubmit || loading}
										sx={{ width: '100%', marginBottom: '8px' }}
										variant="contained"
										onClick={handleSaveClick}
									>
										{saveButtonText}
									</Button>
								</FormButton>
								<FormButton>
									<Button sx={{ width: '100%' }} variant="outlined" onClick={handleCancelEdit}>
										{cancelButtonText}
									</Button>
								</FormButton>
							</Box>
						)}
					</FormCard>
					{dataToEdit! && (
						<Box
							sx={{
								marginTop: '24px',
								display: 'flex',
								flexDirection: 'row-reverse',
								justifyContent: 'space-between',
							}}
						>
							<FormButton>
								<Button
									disabled={disabledSubmit || loading}
									variant="contained"
									onClick={handleSaveClick}
									sx={{ padding: '15px 48px' }}
								>
									{loading ? (
										<CircularProgress sx={{ width: '30px!important', height: '30px!important' }} />
									) : (
										saveButtonText
									)}
								</Button>
							</FormButton>
							<FormButton>
								<Button onClick={handleCancelEdit}>{cancelButtonText}</Button>
							</FormButton>
						</Box>
					)}
				</CenteredNarrowContent>
			</Stack>
		</Box>
	);
}
